<template>
  <div v-if="chosenChildOrg && childOrgsSelector">
    <div class="d-flex flex-row justify-space-between align-center mb-5">
      <h1 class="section-header__title mb-0">
        Сведения о лицензиях
      </h1>
      <div class="structural-unit">
        <label>Выбор структурного подразделения</label>
        <v-autocomplete
          v-model="chosenChildOrg.id"
          :items="childOrgsSelector"
          @change="selectOrganization($event)"
          dense
          clearable
          outlined
        ></v-autocomplete>
      </div>
      <div class="d-flex flex-row align-center">
        <v-btn
          class="white__v-btn orange-hover"
          :loading="getSpecStatus"
          :disabled="blockBtn"
          @click="openDialog('add')"
        >
          Добавить лицензию
        </v-btn>
      </div>
    </div>
    <WrapperPreviewCategory>
      <GridTable
        :data-rows="serverData"
        :headers="headers.massive"
        :headers-for-rows="headersForRows"
        :loading-data="loadingTable"
        :num-cols="headers.countCells"
        :max-table-height="maxTableHeight"
        class="organizations-table"
        ref="npg-table"
        key="form-3-license"
      >
        <template #actions="{row}">
          <v-btn :loading="getSpecStatus" :disabled="blockBtn" @click="openDialog('edit', row)" icon>
            <v-icon size="24" color="primary">mdi-file-edit-outline</v-icon>
          </v-btn>
          <v-btn @click="deleteRow(row)" icon :disabled="blockBtn" :loading="deleteLoading">
            <v-icon size="24" color="primary">mdi-delete-outline</v-icon>
          </v-btn>
        </template>
        <template #npg="{row}">
          <template v-if="row.uslName">
            <div class="font-weight-bold font-size-medium ">
              {{ row.uslName[0].toUpperCase() + row.uslName.slice(1) }}
            </div>
          </template>
          <template v-else>
            <div style="">
              {{ row.spec.code }}
            </div>
            <div class="ml-3">
              {{ row.spec.name }}
            </div>
          </template>
        </template>
        <template #gltxt="{value}">
          <comment-menu :text="value"/>
        </template>
      </GridTable>
      <div class='font-size-small mt-5' style="color: #89A0B0;">
        <img class="mr-3" src="@/assets/icons/forms2-4/Vector_lamp.svg" alt=""/>
        <span>Сведения о наличии лицензий внесены на основании данных конкурса прошлого года</span>
      </div>
    </WrapperPreviewCategory>
    <universal-dialog-v1
      ref="dialog"
      :data-for-dialog="dataForDialog"
      :headers-for-dialog="headersForDialog"
      @fetch-new-data="fetchDialogData($event)"
      :loading="savingData"
      :additional-data="additionalData"
      :spr-data="sprData"
      @closing-dialog="clearDataForDialog()"
    >
      <template #title>
        <h2>{{ mainHeaderTitle ? mainHeaderTitle : 'Добавить' }}</h2>
      </template>
      <template #actions="{close, sendData, loading, validSolo, isOneStage}">
        <div class="d-flex flex-row align-center justify-center" style="width: 100%">
          <v-btn
            class='white__v-btn'
            @click="close"
            width="120px"
          >
            Отменить
          </v-btn>
          <v-btn
            v-if="isOneStage"
            class='white__v-btn orange-hover  ml-2'
            @click="sendData"
            :loading="loading"
            :disabled="!validSolo || disabled"
            width="120px"
          >
            Сохранить
          </v-btn>
        </div>
      </template>
    </universal-dialog-v1>
  </div>
  <!--  <div v-else class="d-flex flex-row align-center" style="min-height: 200px">-->
  <!--    <slot name="loading">-->
  <!--      <v-progress-linear indeterminate/>-->
  <!--    </slot>-->
  <!--  </div>-->
</template>

<script>
import GridTable from "@/components/GridTable/GridTable";
import form3, {headersForDialog} from "@/pages/Organization/Forms2-4/configs/form3";
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import {mapGetters} from "vuex";
import UniversalDialogV1 from "@/components/Dialogs/universalDialog(v1.2)";
import Form3LicenseController from "@/controllers/Organizations/Forms(2-4)/Form3LicenseController";
import {mapSpr} from "@/components/Dialogs/helpers";
import CommentMenu from "@/components/Menus/comments-menu";
import {headerTooltipFunctions} from "@/mixins/forms5/headerTooltip";
import {fiveFormsMixin} from "@/mixins/formUsl";
import {setFileFunctions} from "@/mixins/fileFucntions";


export default {
  name: "form3License",
  mixins: [headerTooltipFunctions, fiveFormsMixin, setFileFunctions],
  components: {
    CommentMenu,
    UniversalDialogV1,
    WrapperPreviewCategory,
    GridTable,
  },
  data() {
    return {
      serverData: [],
      childOrgs: [],
      childOrgsSelector: [],
      chosenChildOrg: null,
      loadingData: false,
      deleteLoading: false,
      headers: form3,
      savingData: false,
      dataForDialog: null,
      additionalData: null,
      mainHeaderTitle: '',
      headersForDialog: headersForDialog,
    }
  },
  computed: {
    ...mapGetters('spr', {getAvailableOrgs: 'getAvailableOrgs'}),
    ...mapGetters('spr', {getSpec: 'getSpec', getSpecStatus: 'getSpecStatus'}),
    ...mapGetters('checkFilled', {currentStage: 'currentStage'}),
    loadingTable() {
      return this.get_spr_data_usl_loading || this.loadingData
    },
    sprData() {
      return {
        sprSpec: mapSpr(this.getSpec, 'id', (el) => el.code + ' ' + el.name),
      }
    },
    maxTableHeight() {
      return window.screen.availHeight - 350 + 'px'
    },
    headersForRows() {
      return this.headers.massive
    },
    blockBtn() {
      if (this.getAuthData?.realm_access?.roles?.includes('ADMIN_ROLE')) {
        return false
      } else if (/*this.currentStage === 4 || */this.currentStage === 5 || this.organizationBlocked) {
        return true
      } else {
        return false
      }
    }
  },
  
  watch: {
    getAvailableOrgs() {
      this.loadingDataTable();
    },
  },
  
  created() {
    this.loadingDataTable();
  },
  
  methods: {
    async loadingDataTable() {
      this.loadingData = true;
      try {
        if (this.chosenChildOrg === null || this.chosenChildOrg === undefined) { //первая загрузка
          this.childOrgs = this.getAvailableOrgs;
          this.childOrgsSelector = this.getAvailableOrgs.map((el) => {
            return {
              text: el.name,
              value: el.id,
            }
          });
          this.chosenChildOrg = this.childOrgs[0];
        }
        
        this.serverData = await Form3LicenseController.getData(this.chosenChildOrg.id);
        
        this.loadingData = false;
      } catch (e) {
        this.loadingData = false;
      }
    },
    
    async deleteRow(row) {
      try {
        const accept = confirm('Вы уверены что хотете удалить эту строку?');
        if (!accept) {
          return;
        }
        this.deleteLoading = true;
        const res = await Form3LicenseController.deleteRow(row.id)
        if (res) {
          const ind = this.serverData.findIndex(el => el.id === row.id);
          if (ind !== -1) {
            this.serverData.splice(ind, 1);
          }
        }
        this.deleteLoading = false;
      } catch (e) {
        console.error('/api/form3/delete', e)
        this.deleteLoading = false;
      }
    },
    
    clearDataForDialog() {
      this.mainHeaderTitle = '';
      this.dataForDialog = null;
      this.additionalData = null;
    },
    
    /**
     * @param {'add' | 'edit'} typeAction
     * @param {Object} [row]
     * */
    async openDialog(typeAction = 'add', row) {
      if (row) {
        if (row.spec) {
          this.mainHeaderTitle = row.spec?.code + ' ' + row.spec?.name;
        }
      }
      if (typeAction === 'edit') {
        this.additionalData = {
          id: row?.id ?? null,
          "spec": row?.spec?.id ? {
            "id": row?.spec?.id,
          } : null,
          "orgId": row.orgId,
        };
        this.dataForDialog = {
          idSprSpec: row.spec?.id,
          glsnm: row.glsnm,
          gldtb: row.gldtb,  //date   this.parseDate(
          gltxt: row.gltxt,
        };
      }
      await this.$refs.dialog.openDialog()
    },
    
    formatDate(date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    
    parseDate(date) {
      if (!date) {
        return null
      }
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    
    /**
     * @param { {
     * gldtb: string,
     * glsnm: string,
     * gltxt: string,
     * id : number | null,
     * idSprSpec : number
     * }} obj
     * */
    async fetchDialogData(obj) {
      this.savingData = true;
      try {
        const mail = {
          ...obj,
          spec: {
            id: obj.idSprSpec,
          },
        }
        const res = await Form3LicenseController.setData(mail, this.chosenChildOrg.id);
        if (res) {
          this.savingData = false;
          if (obj.id) {
            const index = this.serverData.findIndex(el => el.id === obj.id);
            this.serverData.splice(index, 1, res) //res.data
          } else {
            this.serverData.push(res);
          }
          this.dataForDialog = null;
          await this.$refs.dialog.closeDialog();
        }
        this.savingData = false;
      } catch (e) {
        console.error("fetchDialogData", e)
        this.savingData = false;
      }
    },
    
    selectOrganization(org) {
      this.chosenChildOrg = this.childOrgs.find(el => el.id === org);
      this.loadingDataTable();
    },
  },
}
</script>

<style scoped>

</style>